import { ValidatorProvider } from '@dofleini/validator';
import { Form } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';

import { CACHE_KEY_LIST_TECH_PARK } from '@/modules/configuration/contants/techPark';
import TechParkApiService from '@/modules/configuration/services/TechParkApiService';
import { renderMunicipality, renderProvince } from '@/utils/location';
import SelectElementCmp from '@/utils/SelectElementCmp';

import style from './index.less';

const TechParkSelect = ({ value, onChange, filters, ...props }) => {
  const currentValue = value && typeof value === 'object' ? value._id : value;
  
  const onRenderItem = useCallback(({ name, address }) => {
    return <div>
      <div className="flex items-center truncate">
        <div className="font-semibold">{name}</div>
      </div>
      <div className={classNames(style.itemsContainer, 'flex items-center truncate')}>
        {address?.province &&
        <div className="element-contact text-xs truncate">{renderProvince(address?.province)}</div>}
        {address?.municipality &&
        <div className="element-contact text-xs truncate">{renderMunicipality(address?.municipality)}</div>}
      </div>
    </div>;
  }, []);
  
  return (
    <>
      <div className={'w-full'}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_TECH_PARK}
          filters={filters}
          service={TechParkApiService}
          includeValue={value}
          value={currentValue}
          onChange={onChange}
          customItemRender={onRenderItem}
          sort={{ name: 1 }}
          queryConfig={{ refetchOnWindowFocus: false }}
        />
      </div>
    </>
  );
};

TechParkSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  showContact: PropTypes.bool,
  filters: PropTypes.object
};

export default memo(TechParkSelect);

export const renderTechParkSelect = ({ formItemProps, field, form }) => {
  
  const rules = field?.required && [{ required: true, message: ValidatorProvider.t('validateMessages.required') }];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <TechParkSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
